import { render } from '../lib/render'
import { Footer } from '../components/footer'
import '../styles/index.css'

const displayContent = () => {
  document.body.style.visibility = 'visible'
  document.body.style.opacity = '1'
}

const main = () => {
  const parentDiv: HTMLElement = document.querySelector('#left')
  const rightDiv: HTMLElement = document.querySelector('#right')
  const canvas: HTMLCanvasElement = document.querySelector('#canvas')
  const ctx = canvas.getContext('2d')
  Footer(document.querySelector('footer'), 2010)
  const observer = new ResizeObserver(entries => {
    window.requestAnimationFrame(() => {
      const size = Math.min(parentDiv.offsetWidth, rightDiv.offsetHeight)
      const canvasSize = size * devicePixelRatio
      canvas.width = canvasSize
      canvas.height = canvasSize
      canvas.style.width = size + 'px'
      canvas.style.height = size + 'px'
      ctx.scale(devicePixelRatio, devicePixelRatio)
      render({ size, ctx })
    })
  })
  observer.observe(rightDiv)
}

window.addEventListener('DOMContentLoaded', () => {
  main()
  displayContent()
})
